"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ERROR_PREFIX = exports.ERROR_PREFIX = "[cssapi]";
var DATA_PREFIX = exports.DATA_PREFIX = "(config.data)";
var BREAKPOINTS_PREFIX = exports.BREAKPOINTS_PREFIX = "(config.breakpoints)";
var MQ_PREFIX = exports.MQ_PREFIX = "api.mq()";
var API_PREFIX = exports.API_PREFIX = "api()";
var MIXIN_PREFIX = exports.MIXIN_PREFIX = "mixin()";


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/errors.js
// module id = 653
// module chunks = 168707334958949